import {SUCCESS_CODE} from '@/constants';
import {APIError} from '@/constants/error';

const canRefresh = (code: number) => {
    if (code === SUCCESS_CODE) {
        return true;
    }
    if (code === APIError.equityFrozen) {
        return true;
    }
    return false;
};

export default canRefresh;
